import { render } from "./SettingPasswordDone.vue?vue&type=template&id=035e5d27"
import script from "./SettingPasswordDone.vue?vue&type=script&lang=js"
export * from "./SettingPasswordDone.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__